if (!customElements.get("sticky-add-to-cart")) {
  customElements.define(
    "sticky-add-to-cart",
    class StickyAddToCart extends HTMLElement {
      constructor() {
        super()
      }
      connectedCallback() {
        setTimeout(() => {
          this.init()
        })
      }
      init() {
        this.button = this.querySelector("button")
        this.mainCTA = this.closest(".shopify-section").querySelector('button[name="add"]')
        this.intersection()
        this.mutation()
      }
      intersection() {
        let stickyAddOptions = {
          root: null,
          rootMargin: "0px",
          threshold: 0.5
        }
        let stickyAddCallback = (entries, observer) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              this.setAttribute("data-show", false)
            } else {
              this.setAttribute("data-show", true)
            }
          })
        }

        let stickyAddObserver = new IntersectionObserver(stickyAddCallback, stickyAddOptions)

        stickyAddObserver.observe(this.mainCTA)

        this.button.addEventListener("click", (e) => {
          e.preventDefault()
          this.mainCTA.click()
          this.mainCTA.scrollIntoView({ behavior: "smooth" })
        })
      }
      mutation() {
        // Options for the observer (which mutations to observe)
        const config = { attributes: true, childList: true, subtree: true }

        // Callback function to execute when mutations are observed
        const atcMutationCallback = (mutationList, observer) => {
          for (const mutation of mutationList) {
            if (mutation.type === "childList") {
              if (this.mainCTA.innerHTML !== this.button.innerHTML) {
                this.button.innerHTML = this.mainCTA.innerHTML
              }
            } else if (mutation.type === "attributes") {
              if (mutation.attributeName === "disabled") {
                this.mainCTA.getAttribute("disabled")
                  ? this.button.setAttribute("disabled", true)
                  : this.button.removeAttribute("disabled")
              }
            }
          }
        }

        // Create an observer instance linked to the callback function
        const atcMutationObserver = new MutationObserver(atcMutationCallback)

        // Start observing the target node for configured mutations
        atcMutationObserver.observe(this.mainCTA, config)
      }
    }
  )
}
